export enum SkillProficiency {
  REQUIRED,
  OPTIONAL
}
